<!-- Container for a row in the slot list of Program Block/Feed Detail view -->

<template>
   <tr class="slot-row" :recid="slotObject.recid">

      <td colspan="7">

         <program-block-table-row
            :addRow="slotObject.assetRecid < 0"
            :slotObj="slotObject"
            :asset="slotObject.asset"
            :creator="creatorName"
            :feedSlots="slotObject.feedSlots"
            :isTrigger="isTrigger"
            :active="active"
            :expanded="showFeedSlots"
            @editInstance="handleEditInstance"
            @slotClick="handleSlotClick"
            @deleteSlot="handleDeleteSlot"
            @expandFeed="showFeedSlots = !showFeedSlots"
         >
         </program-block-table-row>
         
         <!-- For feeds, show their slots as a sub-list of slots -->
         <div v-if="showFeedSlots">
            <program-block-table-row
               v-for="feedSlot in slotObject.feedSlots"
               :key="'feed-' + feedSlot.recid"
               :addRow="false"
               :isFeedSlot="true"
               :slotObj="feedSlot"
               :slotRecid="slotObject.recid"
               :asset="feedSlot.asset"
               :creator="feedSlot.contributor"
               :active="false"
               :status="'Ready'"
            >
            </program-block-table-row>
         </div>
      </td>
   </tr>
</template>

<script>
import BaseSlotRow from './../../block_detail/BaseSlotRow';

import ProgramBlockTableRow from './ProgramBlockTableRow';

import {mapActions} from 'vuex';

export default {
   extends: BaseSlotRow,

   data() {
      return {
         showFeedSlots: false,
      }
   },

   methods: {
      ...mapActions('global', [
         'closeMediaPicker'
      ]),

      ...mapActions('program_block', [
         'setIsEditingInstanceState'
      ]),
      
      handleEditInstance() {
         this.closeMediaPicker();
         this.setIsEditingInstanceState({isEditing: true});
         this.openSmartCanvas({vm: this, instanceRecid: this.slotObject.asset.origin_fk});
      },
   },
   
   components: {
      ProgramBlockTableRow
   }
}
</script>